import {ApiResponseBody} from "@/library/api/models/api"
import {apiBase} from "@/library/constants"
import {Product, ProductVersion, ProductVersionCreate, ProductVersionUpdate} from "@/library/api/models/changelog"

export const pckChangelog = async (): Promise<Product[]> => {
    const products: ApiResponseBody<Product[]> = await fetch(`${apiBase}/api/changelog/products`)
        .then(res => res.json())

    const refKey = products?.data?.at(0)?.refKey
    if (!refKey)
        return []

    return products.data ?? []
}

export const pckProductVersions = async (productName: string, token?: string) => {
    const headers: { [key: string]: string } = {
        'Content-Type': 'application/json',
    }

    if (token)
        headers['Authorization'] = `Bearer ${token}`

    const changes: ApiResponseBody<ProductVersion[]> = await fetch(`${apiBase}/api/changelog/products/${productName}/changes`, {
        headers: headers
    }).then((res) => res.json())

    return changes.data ?? []
}

export const pckProductVersionCreate = async (version: ProductVersionCreate, token?: string) => {
    const headers: { [key: string]: string } = {
        'Content-Type': 'application/json',
    }

    if (token)
        headers['Authorization'] = `Bearer ${token}`

    return await fetch(`${apiBase}/api/product/versions`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(version)
    }).then(res => res.json())
}

export const pckProductVersionUpdate = async (version: ProductVersionUpdate, token?: string) => {
    const headers: { [key: string]: string } = {
        'Content-Type': 'application/json',
    }

    if (token)
        headers['Authorization'] = `Bearer ${token}`

    return await fetch(`${apiBase}/api/product/versions`, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(version)
    }).then(res => res.json())
}

export const pckProductVersionDelete = async (versionId: number) => {
    return await fetch(`${apiBase}/api/product/versions/${versionId}`, {
        method: 'DELETE',
    }).then(res => res.json())
}
